import { render } from "./AceEditor.vue?vue&type=template&id=13410df6&ts=true"
import script from "./AceEditor.vue?vue&type=script&lang=ts"
export * from "./AceEditor.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__